function loadScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
        if (!url) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = url;
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Errore caricamento script: ${url}`));

        document.head.appendChild(script);
    });
}

function getPageUrl(): URL {
    return new URL(window.location.href);
}

function getNyxEnvName(): string {
    const pageUrl = getPageUrl();

    if (pageUrl.searchParams.get("dev") === "1") {
        return "dev";
    }

    if (pageUrl.searchParams.get("stage") === "1") {
        return "stage";
    }

    return "production";
}

function resolveNyxConfigURL(config: any): string {
    const pageUrl = getPageUrl();
    const envid = pageUrl.searchParams.get("envid");
    if (!envid) return "";

    const envName = getNyxEnvName();

    return (config[envid] && config[envid][envName])
        ? config[envid][envName]
        : "";
}

function resolveNyxLocalConfigURL(): string {
    return "./nyx/config.js";
}

function hasNyxRemoteOverride(): boolean {
    const pageUrl = getPageUrl();
    return pageUrl.searchParams.has("remote");
}

export async function bootstrapExternalScript(config: any): Promise<any> {
    if (!config) return null;

    if (typeof config === "string") {
        await loadScript(config);
        return {
            type: "direct",
            scriptUrl: config
        };
    }

    if (typeof config === "object" && config.type === "nyx") {
        let configUrl = resolveNyxConfigURL(config);

        if (hasNyxRemoteOverride()) {
            configUrl = resolveNyxLocalConfigURL();
        }

        if (!configUrl) {
            throw new Error("NYX config.js non risolto");
        }

        await loadScript(configUrl);

        const gcmConfig = (window as any).GCMConfig;
        if (!gcmConfig || typeof gcmConfig.getGCMUrl !== "function") {
            throw new Error("GCMConfig.getGCMUrl non disponibile");
        }

        const envName = getNyxEnvName();
        const gcmUrl =
            envName === "production"
                ? gcmConfig.getGCMUrl()
                : gcmConfig.getGCMUrl(envName);

        if (!gcmUrl) {
            throw new Error("NYX gcm.js non risolto");
        }

        await loadScript(gcmUrl);

        return {
            type: "nyx",
            configUrl,
            gcmUrl
        };
    }

    return null;
}

export function getExternalBootstrapData(): any {
    return (window as any).MBF_EXTERNAL_BOOTSTRAP || null;
}

export function initNyxGcm(game: any, launchingURL: string): any {
    const gcmNamespace = (window as any).gcm;
    if (!gcmNamespace || !gcmNamespace.GcmCore) {
        throw new Error("gcm.GcmCore non disponibile");
    }

    const bootstrapData = (window as any).MBF_EXTERNAL_BOOTSTRAP;
    const gcmUrl = bootstrapData?.gcmUrl;

    if (!gcmUrl) {
        throw new Error("gcmUrl non disponibile");
    }

    const gcmInstance = new gcmNamespace.GcmCore();
    gcmInstance.init(game, gcmUrl, launchingURL);

    return gcmInstance;
}